import styled from "@emotion/styled";
import {
  Col,
  Dropdown,
  Menu,
  Image,
  Modal,
  Tag,
  Typography,
  message,
} from "antd";
import { FC, useEffect, useState } from "react";
import { locationIcon } from "assets/icons";
import {
  LoadAgentContactsData,
  deleteAgentImmediatelyInput,
} from "services/interface";
import { ExclamationCircleFilled, MoreOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import noImage from "assets/images/no-image.png";
import { formatDateWithTime } from "utils/dateFormat";
import { useDeleteUserImmediately } from "hooks/useFactory";
import { useAppSelector } from "store";
const { confirm } = Modal;

interface AgentDataCardProps {
  data: LoadAgentContactsData;
  refetch: () => void;
  handleAfterDelete: () => void;
}

const AgentDataCard: FC<AgentDataCardProps> = ({
  data,
  refetch,
  handleAfterDelete,
}) => {
  // data, refetch, refetchTo

  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    setImageError(false);
  }, [data?.image]);

  const { mutate: deleteUser } = useDeleteUserImmediately();

  const { contact } = useAppSelector((state) => state.auth);

  const factoryId = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );

  const navigate = useNavigate();

  const updateNavigate = (id: string) => {
    navigate(`/manage-agent/update-agent/${id}`);
  };

  const showDeleteConfirm = (id: string) => {
    if (!id) return;
    const data: deleteAgentImmediatelyInput = {
      ref_id: id,
      ref_type: "agent",
      remark: "ยื่นคำร้องขอลบตัวแทน",
      factory_id: factoryId || "",
    };
    confirm({
      title: "คุณต้องการลบผู้ใช้งานนี้ใช่หรือไม่",
      icon: <ExclamationCircleFilled />,
      content: "ผู้ใช้ตัวแทนนี้จะหายไปจากระบบ และ ไม่สามารถกู้คืนได้",
      okText: "ใช่, ต้องการลบ",
      okType: "danger",
      cancelText: "ไม่, ยกเลิกการลบ",
      onOk() {
        deleteUser(data, {
          onSuccess: (data) => {
            if (data.status === "success") {
              message.success("ลบ ตัวแทน สำเร็จ");
              refetch();
              handleAfterDelete();
            } else {
              message.error(`${data.error_message}`);
            }
          },
          onError: () => {
            message.error("ลบ ตัวแทนร็จ");
          },
        });
      },
      onCancel() {
        //console.log("Cancel");
      },
    });
  };

  return (
    <Col sm={24} md={8} xl={8} span={24}>
      <CardContainer>
        <ImageWrapper>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Image
              // width={180}
              src={!imageError && data?.image ? data.image : noImage}
              onError={() => setImageError(true)}
              style={{ objectFit: "cover" }}
            />
          </div>
        </ImageWrapper>
        <Content
          style={{ cursor: "pointer" }}
          onClick={() => {
            updateNavigate(data.id);
          }}
        >
          <TextWrapper>
            <Typography.Text className="text-order-agent-name-underline">
              {data && data.contact_name && data?.contact_name.length > 50
                ? data?.contact_name.slice(0, 50) + "..."
                : data?.contact_name}
            </Typography.Text>
            <Typography.Text className="text-order-agent-name">
              {data && data.alias ? `(${data.alias})` : ""}
            </Typography.Text>
          </TextWrapper>
          
            <>
              <TextWrapper>
                <Typography.Text className="text-order-product-name">
                  {locationIcon}
                </Typography.Text>
                <Typography.Text className="text-order-product-name">
                  {data?.location || "-"}
                </Typography.Text>
              </TextWrapper>

              <Typography.Text className="text-order-product-name">
                {[data?.telephone, ...(data?.contact_mobile || [])].join(", ") ||
                  "-"}
              </Typography.Text>

              <TextWrapper>
                <Typography.Text className="text-order-product-name">
                  {/*วันที่ทำรายการสั่งซื้อล่าสุด: TODO: ต้องเปลี่ยนเป็นวันที่ทำรายการสั่งซื้อล่าสุด* จะทำในภายหลัง*/}
                วันที่ทำรายการสั่งซื้อล่าสุด: {" "}
                  {formatDateWithTime(data?.create_date || "")}
                </Typography.Text>
                <Typography.Text className="text-order-product-name"></Typography.Text>
              </TextWrapper>

              {contact?.code === "lunganek" ? (
              <TextWrapper>
                <Typography.Text className="text-order-product-name">
                  ผู้สร้าง:
                </Typography.Text>
                <Typography.Text className="text-order-product-name">
                  {data?.create_name.trim() || "-"}
                </Typography.Text>
              </TextWrapper>
              ) : (
                <>
                </>
              )}
              <TextWrapper>
                <Typography.Text className="text-order-product-name">
                  สถานะข้อมูล:
                </Typography.Text>
                <Typography.Text className="text-order-product-name">
                  {data?.is_active ? (
                    <Tag color="blue">Active</Tag>
                  ) : (
                    <Tag color="grey">Inactive</Tag>
                  )}
                </Typography.Text>
              </TextWrapper>

              <TextWrapper style={{ marginTop: "5px" }}>
                <Typography.Text className="text-order-product-name">
                  {data?.line_id ? (
                    <Tag color="green">เชื่อมต่อกับไลน์แล้ว</Tag>
                  ) : (
                    <Tag>ยังไม่ได้เชื่อมต่อกับไลน์</Tag>
                  )}
                </Typography.Text>
              </TextWrapper>
            </>
        </Content>
        <MoreOptionsContainer>
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item
                  key="1"
                  onClick={() => {
                    updateNavigate(data.id);
                  }}
                >
                  จัดการข้อมูล
                </Menu.Item>
                {contact?.code === "lunganek" ? (
                  <Menu.Item
                    key="2"
                    onClick={() => {
                      showDeleteConfirm(data.id);
                    }}
                  >
                    ลบผู้ใช้
                  </Menu.Item>
                ) : (
                  <></>
                )}
              </Menu>

            }
          >
            <MoreOptions>
              <MoreOutlined />
            </MoreOptions>
          </Dropdown>
        </MoreOptionsContainer>
      </CardContainer>
    </Col>
  );
};

export default AgentDataCard;

const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CardContainer = styled.div`
  display: flex;
  align-items: flex-start;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 16px;
  height: 100%;
`;
// box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

const MoreOptionsContainer = styled.div`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
`;

const MoreOptions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #e0e0e0;
  }
`;
const ImageWrapper = styled.div`
  width: 60px;
  height: 60px;
  background-color: #efefef;
  margin-right: 10px;
`;
